export default {
  hero: {
    object: "Purchase Contract Comparison",
    title: "Compare Alternatives to EDF OA",
    description:
      "Explore different options for selling the energy produced by your solar panels. Discover alternatives to the EDF OA purchase contract and find the solution that best fits your needs.",
  },
  offers: {
    "learn-more": "Learn more",
    "most-popular": "Most popular",
    "electricity-grid": "Electric grid",
    "system-power": "System power",
    "subscribed-power": "Subscribed power",
    "consumption-client": "Client consumption",
    "rge-installer": "RGE Installer",
    filters: {
      all: "All",
      "virtual-battery": "Virtual battery",
      contract: "Purchase contract",
      "price-type": "Price type per kWh",
      "starting-fees": "Application fees",
      "additional-fees": "Subscription costs",
      "electricity-grid": "Availability",
      "system-power": "Photovoltaic power",
      "consumption-client": "Mandatory self-consumption",
      "requires-rge-installer": "Requires RGE installer",
    },

    cards: {
      "edf-oa-1": {
        provider: "EDF OA",
        title: "Obligation d’Achat (S21)",
        description:
          "State-guaranteed feed-in tariff for 20 years in mainland France.",
        "price-type": "Fixed price",
        price: "€0.040 - €0.095 / kWh", //conditional on system power in kwc
        "starting-fees": "€0",
        "additional-fees": "€0",
        eligibility: {
          "electricity-grid": "Mainland France",
          "system-power": "0 kWp - 500 kWp",
          "consumption-client": "No",
          "requires-rge-installer": "Yes",
        },
      },
      "edf-oa-2": {
        provider: "EDF OA",
        title: "Obligation d’Achat (S24 in ZNI)",
        description:
          "State-guaranteed feed-in tariff for 20 years in overseas territories.",
        "price-type": "Fixed price",
        price: "Up to €0.1786 / kWh", //conditional on system power in kwc
        "starting-fees": "€0",
        "additional-fees": "€0",
        eligibility: {
          "electricity-grid": "Overseas territories (DROM-COM)",
          "system-power": "0 kWp - 500 kWp",
          "consumption-client": "No",
          "requires-rge-installer": "Yes",
        },
      },
      "ohm-energie": {
        provider: "Ohm Énergie",
        title: "Ohm Virtual Battery",
        description:
          "The only offer from an energy provider with unique benefits.",
        "price-type": "Fixed price",
        price: "€0.90 excl. tax per kWp / month",
        "starting-fees": "0 €",
        "additional-fees": "0 €",
        eligibility: {
          "electricity-grid": "Overseas territories (DROM-COM)",
          "system-power": "0 kWp - 36 kWp",
          "consumption-client": "Yes",
          "requires-rge-installer": "No",
        },
      },
      sunology: {
        provider: "Sunology",
        title: "Surplus +",
        description: "Purchase contract at a fixed price",
        "price-type": "Fixed price",
        price: "€0.10 / kWh",
        eligibility: {
          "electricity-grid": "Mainland France",
          "system-power": "0 kWp - 36 kWp",
          "consumption-client": "No",
          "requires-rge-installer": "No",
        },
      },
      "3erl-1": {
        provider: "Association 3ERL",
        title: "Purchase of photovoltaic surplus",
        description:
          "Ecological, Economical, Renewable, and Local Electricity.",
        "price-type": "Variable price",
        price: "70% of SPOT price",
        "starting-fees": "€0",
        "additional-fees": "€0",
        eligibility: {
          "electricity-grid": "Mainland France",
          "system-power": "9999 kWp",
          "consumption-client": "No",
          "requires-rge-installer": "No",
        },
      },
      "ekwateur-1": {
        provider: "Ekwateur",
        title: "Resale with Ekwateur contract",
        description: "Buyback offer of surplus with Ekwateur benefits.",
        "price-type": "Variable price",
        price: "Around €0.06 / kWh",
        "starting-fees": "€0",
        "additional-fees": "€1 per kWp per month",
        eligibility: {
          "electricity-grid": "Mainland France",
          "system-power": "0 kWp - 36 kWp",
          "consumption-client": "Yes",
          "requires-rge-installer": "No",
        },
      },
      "ekwateur-2": {
        provider: "Ekwateur",
        title: "Resale without Ekwateur contract",
        description: "Buyback offer of surplus without Ekwateur benefits.",
        "price-type": "Variable price",
        price: "Around €0.04 / kWh",
        "starting-fees": "€150",
        "additional-fees": "€1 per kWp per month",
        eligibility: {
          "electricity-grid": "Mainland France",
          "system-power": "0 kWp - 36 kWp",
          "consumption-client": "No",
          "requires-rge-installer": "No",
        },
      },
      "urban-solar-1": {
        provider: "Urban Solar Energy",
        title: "Boost My Surplus ≤ 36 KVA",
        description:
          "Surplus resale for individuals, no commitment, no RGE required.",
        "price-type": "Variable price",
        price: "Around €0.03 / kWh",
        "starting-fees": "€249 incl. tax",
        "additional-fees": "€1 per kWp per month",
        eligibility: {
          "electricity-grid": "Mainland France",
          "system-power": "0 kWp - 36 kWp",
          "consumption-client": "No",
          "requires-rge-installer": "No",
        },
      },
      "urban-solar-2": {
        provider: "Urban Solar Energy",
        title: "Boost My Surplus > 36 KVA",
        description:
          "Surplus resale for professionals, no commitment, no RGE required.",
        "price-type": "Variable price",
        price: "Around €0.03 / kWh",
        "starting-fees": "€650 incl. tax",
        "additional-fees": "€1 per kWp per month",
        eligibility: {
          "electricity-grid": "Mainland France",
          "system-power": "36 kWp - 250 kWp",
          "consumption-client": "No",
          "requires-rge-installer": "No",
        },
      },
      "urban-solar-3": {
        provider: "Urban Solar Energy",
        title: "Virtual Storage (for individuals)",
        description:
          "Store and withdraw your non-self-consumed electricity without limit, without additional equipment and complete freedom.",
        "price-type": "€1 excl. tax per kWp/month",
        price: "€1 excl. tax per kWp/month",
        "starting-fees": "€299",
        "additional-fees": "€0",
        eligibility: {
          "electricity-grid": "Mainland France",
          "system-power": "0 kWp - 36 kWp",
          "consumption-client": "Yes",
          "requires-rge-installer": "No",
        },
      },
      "urban-solar-4": {
        provider: "Urban Solar Energy",
        title: "Virtual Storage (for professionals)",
        description:
          "Store and withdraw your non-self-consumed electricity without limit, without additional equipment and complete freedom.",
        "price-type": "€1 excl. tax per kWp/month",
        price: "€1 excl. tax per kWp/month",
        "starting-fees": "€299",
        "additional-fees": "€0",
        eligibility: {
          "electricity-grid": "Mainland France",
          "system-power": "0 kWp - 36 kWp",
          "consumption-client": "Yes",
          "requires-rge-installer": "No",
        },
      },
      "jpme-1": {
        provider: "JPME",
        title: "E-Surplus Fixed Individuals",
        description: "Lifetime fixed purchase rate for individuals.",
        "price-type": "Fixed price",
        price: "€0.08 / kWh",
        "starting-fees": "€499",
        "additional-fees": "€0",
        eligibility: {
          "electricity-grid": "Mainland France",
          "system-power": "0 kWp - 36 kWp",
          "consumption-client": "No",
          "requires-rge-installer": "No",
        },
      },
      "jpme-2": {
        provider: "JPME",
        title: "E-Surplus Flex Individuals",
        description: "Rate evolves according to SPOT market fluctuations.",
        "price-type": "Variable price",
        price: "SPOT price",
        "starting-fees": "€649",
        "additional-fees": "€0",
        eligibility: {
          "electricity-grid": "Mainland France",
          "system-power": "0 kWp - 36 kWp",
          "consumption-client": "No",
          "requires-rge-installer": "No",
        },
      },
      "jpme-3": {
        provider: "JPME",
        title: "E-Surplus Fixed Professionals",
        description: "Lifetime fixed purchase rate for professionals.",
        "price-type": "Fixed price",
        price: "€0.08 / kWh",
        "starting-fees": "€990",
        "additional-fees": "€0",
        eligibility: {
          "electricity-grid": "Mainland France",
          "system-power": "36 kWp - 250 kWp",
          "consumption-client": "No",
          "requires-rge-installer": "No",
        },
      },
      "jpme-4": {
        provider: "JPME",
        title: "E-Surplus Flex Professionals",
        description: "Rate evolves according to SPOT market fluctuations.",
        "price-type": "Variable price",
        price: "SPOT price",
        "starting-fees": "€990",
        "additional-fees": "€0",
        eligibility: {
          "electricity-grid": "Mainland France",
          "system-power": "36 kWp - 250 kWp",
          "consumption-client": "No",
          "requires-rge-installer": "No",
        },
      },
      "jpme-e-battery": {
        provider: "JPME",
        title: "E-battery (3 kVA - 15 kVA)",
        description:
          "The historical virtual battery offer from JPME, with no subscription.",
        "price-type": "Variable price",
        price: "Application fee €669",
        "starting-fees": "€990",
        "additional-fees": "€0",
        eligibility: {
          "electricity-grid": "Mainland France",
          "system-power": "3 kVA - 15 kVA",
          "consumption-client": "Yes",
          "requires-rge-installer": "No",
        },
      },
      "jpme-e-battery-2": {
        provider: "JPME",
        title: "E-battery (18 kVA - 36 kVA)",
        description:
          "The historical virtual battery offer from JPME, with no subscription.",
        "price-type": "Variable price",
        price: "Application fee €889",
        "starting-fees": "€990",
        "additional-fees": "€0",
        eligibility: {
          "electricity-grid": "Mainland France",
          "system-power": "15 kVA - 36 kVA",
          "consumption-client": "Yes",
          "requires-rge-installer": "No",
        },
      },
      "my-light-1": {
        provider: "mylight150",
        title: "MySmartBattery",
        description:
          "The MySmartBattery virtual battery, a smart box solution with virtual storage, no kWh fee from €15/month.",
        "price-type": "Unknown",
        price: "From €15 / month",
        "starting-fees": "Unknown",
        "additional-fees": "Unknown",
        eligibility: {
          "electricity-grid": "Mainland France",
          "system-power": "Unknown",
          "consumption-client": "Yes",
          "requires-rge-installer": "No",
        },
      },
      "my-light-2": {
        provider: "mylight150",
        title: "MyBattery",
        description:
          "The MyBattery virtual battery, a solution to store your solar energy without limits, no required equipment.",
        "price-type": "€1 excl. tax per kWp/month",
        price: "€1 excl. tax per kWp/month",
        "starting-fees": "Unknown",
        "additional-fees": "Unknown",
        eligibility: {
          "electricity-grid": "Mainland (Enedis)",
          "subscribed-power": "<36 kVa",
          "consumption-client": "Yes",
          "requires-rge-installer": "No",
        },
      },
      "octopus-energy-1": {
        provider: "Octopus Energy",
        title: "SolarPlus Buyback Offer",
        description: "Pilot offer from Octopus to buy your energy.",
        "price-type": "Fixed price",
        price: "€0.13 / kWh",
        "starting-fees": "€0",
        "additional-fees": "€0",
        eligibility: {
          "electricity-grid": "Mainland France",
          "system-power": "0 kWp - 36 kWp",
          "consumption-client": "Yes",
          "requires-rge-installer": "No",
        },
      },
      "octopus-energy-2": {
        provider: "Octopus Energy",
        title: "Octopus Energy Business",
        description: "Personalized purchase prices for large producers.",
        "price-type": "Unknown",
        price: "Unknown",
        "starting-fees": "Unknown",
        "additional-fees": "Unknown",
        eligibility: {
          "electricity-grid": "Mainland France",
          "system-power": "36 kWp - 250 kWp",
          "consumption-client": "Yes",
          "requires-rge-installer": "No",
        },
      },
      "mint-energie-1": {
        provider: "Mint Énergie",
        title: "Electricity buyback by Mint Énergie",
        description:
          "We are currently revising our solar surplus buyback offers.",
        "price-type": "Unknown",
        price: "Unknown",
        "starting-fees": "Unknown",
        "additional-fees": "Unknown",
        eligibility: {
          "electricity-grid": "Mainland France",
          "system-power": "Unknown",
          "consumption-client": "Unknown",
          "requires-rge-installer": "Unknown",
        },
      },
      "total-energies-1": {
        provider: "Total Energies",
        title: "Total Energies purchase contract",
        description: "Purchase contract outside of the obligation to purchase.",
        "price-type": "Unknown",
        price: "Unknown",
        "starting-fees": "Unknown",
        "additional-fees": "Unknown",
        eligibility: {
          "electricity-grid": "Mainland France",
          "system-power": "Unknown",
          "consumption-client": "Unknown",
          "requires-rge-installer": "Unknown",
        },
      },
      "enercoop-1": {
        provider: "Enercoop",
        title: "Producers less than 200 MWh/year",
        description:
          "Offer outside purchase obligation for small citizen collectives or communities.",
        "price-type": "Fixed price",
        price: "€0.065 / kWh",
        "starting-fees": "€0",
        "additional-fees": "€0",
        eligibility: {
          "electricity-grid": "Mainland France",
          "system-power": "0 kWp - 36 kWp",
          "consumption-client": "Yes",
          "requires-rge-installer": "No",
        },
      },
      "enercoop-2": {
        provider: "Enercoop",
        title: "Producers more than 200 MWh/year",
        description:
          "Offer outside purchase obligation for large citizen collectives or communities.",
        "price-type": "Unknown",
        price: "Unknown",
        "starting-fees": "Unknown",
        "additional-fees": "Unknown",
        eligibility: {
          "electricity-grid": "Mainland France",
          "system-power": "36 kWp - 250 kWp",
          "consumption-client": "Yes",
          "requires-rge-installer": "No",
        },
      },
      kwatts: {
        provider: "Kwatts",
        title: "Production Buyback",
        description: "Production buyback at the RTE deviation price.",
        "price-type": "Market price",
        price: "Around €0.05 / kWh",
        "starting-fees": "Unknown",
        "additional-fees": "Unknown",
        eligibility: {
          "electricity-grid": "Mainland France",
          "system-power": "0 kWp - 500 kWp",
          "consumption-client": "No",
          "requires-rge-installer": "No",
        },
      },
      "my-solar-kit": {
        provider: "MK-Surplus",
        title: "MK-surplus (with validated Consuel)",
        description:
          "Surplus resale for Mon Kit Solaire clients with Consuel-validated installation.",
        "price-type": "Fixed price",
        price: "€0.10 / kWh",
        "starting-fees": "€499",
        "additional-fees": "€0",
        eligibility: {
          "electricity-grid": "Enedis",
          "system-power": "0 kVA - 36 kVA",
          "consumption-client": "No",
          "requires-rge-installer": "No",
        },
      },
      "my-solar-kit-2": {
        provider: "MK-Surplus",
        title: "MK-surplus (without validated Consuel)",
        description:
          "Surplus resale for Mon Kit Solaire clients with non-Consuel-validated installation.",
        "price-type": "Fixed price",
        price: "€0.10 / kWh",
        "starting-fees": "€699",
        "additional-fees": "€0",
        eligibility: {
          "electricity-grid": "Enedis",
          "system-power": "0 kVA - 36 kVA",
          "consumption-client": "No",
          "requires-rge-installer": "No",
        },
      },
    },
  },
  process: {
    radios: {
      "new-project": "New project",
      "switch-form-current-contract": "Switch from current contract",
    },
    "new-project": {
      title:
        "How to sell your surplus and maximize the value of your solar electricity production?",
      description:
        "Surplus sale or total sale, purchase contract or virtual battery—consider improving your investment’s profitability.",
      timeline: {
        decision: {
          title: "1. Choose your economic model",
          description:
            "Study the alternatives and their suitability to your solar potential and your electricity consumption.",
        },
        install: {
          title: "2. Install with an RGE-qualified professional",
          description:
            "Get several quotes to compare offers and choose a non-subcontracting installer with the RGE label.",
        },
        enedis: {
          title: "3. Quickly submit the grid connection request",
          description:
            "Ensure proper completion of the grid connection request with Enedis (or local utility) to secure your case.",
        },
        "finish-grid-connection": {
          title: "4. Get your photovoltaic installation commissioned",
          description:
            "Speed up the process with excellent follow-up and obtain your Consuel certificate of compliance.",
        },
        sign: {
          title: "5. Sign with EDF OA or another contracting party",
          description:
            "Start your solar experience off right from day one with a contract that maximizes every kWh produced.",
        },
      },
    },
    "switch-from-current-contract": {
      title: "How to switch purchase contracts?",
      description: "",
      // Maarten said we have to ask Naina for this timeline
      timeline: {},
    },
  },
  CTA: {
    title:
      "Start your solar project today with the purchase contract of your choice",
    description: "",
    button: "Start today",
  },
}
